import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import * as moment from 'moment';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { MerchantTransactionSearch } from 'src/app/models/merchant-transactions';
import { countries } from 'src/app/utilities/countries';
import { emptyFields, UsersType, ReportTerminals, settlementDocumentStatusOptions, appCodeValue, textForSettlementDocumentStatus, SettlementDocumentStatus, gstColumnName } from 'src/app/utilities/common-file';
import { SettlementService } from '../../settlements/settlements.service';
import { MerchantSearch } from 'src/app/models/merchant';
import { DownloadService } from 'src/app/reports/download-service';
import { DateRange, MomentHelper } from '../../models/date';
import { LocationSearch } from 'src/app/models/locations';
import { Messages } from 'src/app/utilities/message';
import { ViewSettlementDetailsComponent } from '../../view-details/view-settlement-details.component';
import { CommonService } from 'src/app/utilities/common-service';
import { ViewSettledTransactionsComponent } from 'src/app/view-details/view-settled-transactions.component';
import { ViewReceiptsComponent } from 'src/app/view-receipts/view-receipts.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-settlement-report',
  templateUrl: './settlements.component.html',
})
export class SettlementsComponent implements OnInit {
  selectedData: any;
  merchantId: any;
  locationId: any;
  loginUserType = '';
  userType = UsersType;
  loading = false;
  showDownload: string;
  settlementName: string;
  countries = countries;
  documentStatusOptions = settlementDocumentStatusOptions;
  settlementDocumentStatus = SettlementDocumentStatus;
  merchantCurrency: any;
  emptyField = emptyFields;
  downloadList = [];
  downloadListForLedger = [];
  selectedDateRange: Date[] = null;
  locationsList = []
  totalAmount=0;
  currencySymbol='';
  totalBankFee=0; 
  totalTransactionFee=0 
  totalNetAmount=0;
  totalCommission=0;
  totalGST =0;
  grandTotal=0;
  totalFlexmGst = 0;
  totalFlexmFee = 0;
  gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
  gstColumnName = gstColumnName;
  columnName :any;
  private tableData: NzTableData<MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>(
    new MerchantTransactionSearch(), 'transactionStatus');

  private tableDataForMerchants: NzTableData<MerchantSearch, any> = new NzTableData<MerchantSearch, any>(
    new MerchantSearch(), 'transactionStatus');

  private tableDataForLocations: NzTableData<LocationSearch, any> = new NzTableData<LocationSearch, any>
  (new LocationSearch(), 'fullName');

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private settlementService: SettlementService,
    private drawerService: NzDrawerService,
    private downloadService: DownloadService,
    private notification: NzNotificationService,

  ) {

  }
  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.merchantId = this.authService.getMerchantId();
    this.locationId = this.authService.getLocationId();
    this.loginUserType = this.authService.getRole();
    this.getMerchant();
    if (this.locationId) {
        this.tableData.search.locationId = this.locationId;
    }
    this.getSettlementDocuments();
  }
  // For Showing currency symbol
  getMerchant() {
        this.tableDataForMerchants.data[0] = this.authService.getMerchantDetails();
        this.merchantCurrency = this.tableDataForMerchants.data[0].currency;
        this.getLocations();
  }
  // For Locations dropdown
  getLocations() {
    this.locationsList = this.authService.getLocationDetails();
  }
  // For List
  getSettlementDocuments(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.settlementService.getSettlementDocumentsWithLimit(this.tableData).subscribe(
      (response: any) => {
        this.totalTransactionFee=response.data.totalTransactionFee.toFixed(2);
        this.totalNetAmount=response.data.totalNetAmount.toFixed(2);
        this.totalBankFee=response.data.totalBankFee.toFixed(2);
        this.totalAmount=response.data.totalAmount.toFixed(2);
        this.grandTotal=response.data.grandTotal.toFixed(2);
        this.totalCommission=response.data.totalCommission.toFixed(2);
        this.totalGST=response.data.totalGst.toFixed(2);
        this.totalFlexmGst = response.data.totalFlexmGst.toFixed(2);
        this.totalFlexmFee = response.data.totalFlexmFee.toFixed(2);
        this.loading = false;
        this.tableData.total = response.data.total;
        this.tableData.data = response.data.transactions;
        this.showDownload = Messages.downloadReport;
        this.currencySymbol = this.commonService.getCurrencySymbol(this.authService.getAppCode() === appCodeValue.all? '': this.authService.getAppCode());
      },
      () => {
        this.loading = false;
        this.tableData.data = [];
      }
    );
  }
  // For Date range change
  onUpdatedOnChange(range: any[]) {
    if (range.length <= 1) {
      return;
    }
    this.tableData.search.createdDate = MomentHelper.createDateRange(range);
    this.getSettlementDocuments();
  }
  // For reset date range
  updateClear(range: any[]) {
    if (range.length <= 1) {
      this.tableData.search.createdDate = DateRange.empty();
      return;
  }
  }
  // For Page Index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.getSettlementDocuments(false);
  }

  getSettlementDocumentStatus(status) {
    return this.commonService.getSettlementDocumentStatus(status);
  }
  getColorForSettlementDocumentStatus(status) {
    return this.commonService.getColorForSettlementDocumentStatus(status);
  }
  getCurrency(currency) {
    const index = this.countries.findIndex((M) => M.currency_code === currency);
    if (index !== -1) {
      return this.countries[index].currency_symbol;
    }
  }
  // For View drawer
  viewDetails(data) {
    this.selectedData = data;
    const drawerRefCreate = this.drawerService.create<ViewSettlementDetailsComponent, { value: any }, string>({
      nzContent: ViewSettlementDetailsComponent,
      nzWidth: '700px',
      nzClosable: true,
      nzContentParams: {
        value: this.selectedData
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    // tslint:disable-next-line: no-shadowed-variable
    drawerRefCreate.afterClose.subscribe((data) => {
     if (data && typeof data !== null) {
       this.getSettlementDocuments();
     }
    });
  }
  // For Download Excel
  downloadReport() {
    if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
      this.notification.info('Download Processing', 'Please Wait', {
        nzKey : 'key'
      });
      const value = {
        merchantId: this.authService.getMerchantId(),
        locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
        startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
        endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
        status: this.tableData.search.status,
        settlementStatus: this.tableData.search.settlementStatus
    };
    // For Filter Headers
      const filterHeaders = ['Created On', 'Location Name', 'Status'];
    // To Show Filtered Data
      const filterData = [this.tableData.search.createdDate ? moment(this.tableData.search.createdDate.startDate)
    .local().format('DD-MMM-YYYY') + ' to ' + moment(this.tableData.search.createdDate.endDate).local().format('DD-MMM-YYYY') : '',
      this.tableData.search.locationId ? this.locationsList.find(x => x.id === this.tableData.search.locationId).name : 'All',
      this.tableData.search.settlementStatus === '' ? 'All' : this.tableData.search.settlementStatus ? 'Paid' : 'Open'
    ];
    var gridFooter;
    var footerData;
    if(this.gst){
      gridFooter = ['Total Amount','Total TransactionFee','Total '+this.columnName,'Total FlexM Fee','Total Commission','Total GST','Grand Commission Total','Total BankFee','Total Net Amount'];      
      footerData=[
       this.currencySymbol+this.totalAmount,
       this.currencySymbol+this.totalTransactionFee,
       this.currencySymbol + this.totalFlexmGst,
       this.currencySymbol + this.totalFlexmFee,
       this.currencySymbol+this.totalCommission,
       this.currencySymbol+this.totalGST,
       this.currencySymbol+this.grandTotal,
       this.currencySymbol+this.totalBankFee,
       this.currencySymbol+this.totalNetAmount
       ];
    }else{
      gridFooter = ['Total Amount','Total TransactionFee','Total Commission','Total GST','Grand Commission Total','Total BankFee','Total Net Amount'];      
      footerData=[
       this.currencySymbol+this.totalAmount,
       this.currencySymbol+this.totalTransactionFee,
       this.currencySymbol+this.totalCommission,
       this.currencySymbol+this.totalGST,
       this.currencySymbol+this.grandTotal,
       this.currencySymbol+this.totalBankFee,
       this.currencySymbol+this.totalNetAmount
       ];
    }
        // For Footer 
    // API request
      this.settlementService.downloadReportForMerchantSettlement(value).subscribe((response: any) => {
      this.tableData.total = response.data.total;
      this.downloadList = response.data.transactions;
      if (this.downloadList.length > 0) {
        var headers;
        if(this.gst){
          headers = ['ID','Document No','Merchant','Location', 'Status' , 'User Type', 'Settlement Amount', 'Transaction Fee',this.columnName,'Total Flexm Fee','Commission','GST','Total Commission', 'Bank Fee', 'Net Amount Transferred', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];
        }else{
          headers = ['ID','Document No','Merchant','Location', 'Status' , 'User Type', 'Settlement Amount', 'Transaction Fee','Commission','GST','Total Commission', 'Bank Fee', 'Net Amount Transferred', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];
        }
        // tslint:disable-next-line: max-line-length
        // tslint:disable-next-line: max-line-length
        this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantSettlementReport, this.tableData.search.createdDate.startDate, this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantSettlementReport, ReportTerminals.merchantSettlementReport, filterHeaders, filterData,gridFooter,footerData);
      }
    });
   } else {
      this.notification.error(Messages.noDateSelected, '', {
        nzKey : 'key'
      });
    }
  }
// View Transactions
viewTransactions(data) {
  this.selectedData = data;
  const drawerReceipt = this.drawerService.create<ViewSettledTransactionsComponent, { selectedTransaction: any}, string>({
    nzContent: ViewSettledTransactionsComponent,
    nzWidth: '850px',
    nzClosable: true,
    nzContentParams: {
      selectedTransaction: this.selectedData,
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      padding: '0'
    }
  });
  // tslint:disable-next-line: no-shadowed-variable
  drawerReceipt.afterClose.subscribe((data) => {
    if (data && typeof data !== null) {
    }
   });
}
// View Receipt
viewReceipt(data) {
  this.selectedData = data;
  const drawerReceipt = this.drawerService.create<ViewReceiptsComponent, { id: any, type: string, settlementData: any }, string>({
    nzContent: ViewReceiptsComponent,
    nzWidth: '750px',
    nzClosable: true,
    nzContentParams: {
      id: this.selectedData.id,
      type: 'settlement',
      settlementData: this.selectedData
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      padding: '0'
    }
  });
  // tslint:disable-next-line: no-shadowed-variable
  drawerReceipt.afterClose.subscribe((data) => {
    if (data && typeof data !== null) {
    }
   });
}
// Get tag Text for the Users Type
getUsersType(type) {
  return this.commonService.getUsersType(type);
}
// Get tag color for the Users Type
getUsersTypeColor(type) {
  return this.commonService.getUsersTypeColor(type);
}
}
